/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SKUCreateInput { 
    archived?: boolean;
    createdAt?: string;
    displayName?: string;
    extraPrice?: number;
    id?: string;
    locked?: boolean;
    published?: boolean;
    quantity?: number;
    readOnly?: boolean;
    sku?: string;
    updatedAt?: string;
    version?: number;
}
